module.exports = "<div class=\"aside\" id=\"addCard\" content>\n\t<ui-view sidebar=\"sidebar\"></ui-view>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-card/template.html
 ** module id = 332
 ** module chunks = 1
 **/